import { BaseEntity } from "../base-entity";
import { BreezeModelBuilder } from "../breeze-model-builder";
import { Person } from "../person/person";
import { Item } from "./item";
import { Objective } from "./objective";

export enum WatcherLinkAddedBy {
    Mention = "Mention",
    User = "User",
}

export class WatcherLink extends BaseEntity<WatcherLink> {
    public watcherLinkId!: number;
    public personId!: number;
    public addedBy!: WatcherLinkAddedBy;

    public itemId?: number;
    public objectiveId?: number;

    public person!: Person;
    public objective?: Objective;
    public item?: Item;
}

export const WatcherLinkBreezeModel = new BreezeModelBuilder("WatcherLink", WatcherLink)
    .hasSource()
    .isOrganisationEntity()
    .build();
